module.exports = __webpack_public_path__ + "img/login.71af44ba.png";